export enum ContactsGroupType {
  AllInvestors,
  Holding,
  General,
  AllContacts,
}
